module.exports = __webpack_public_path__ + "static/media/linea_5.528758fe.svg";